import * as React from 'react';

import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import { FR_FRIEND_LIST_TEXT_KEYS } from '../fr-friend-list-common';
import './fr-friend-list-no-friends.styles.less';

export class FRFriendListNoFriends extends React.Component<ITranslationProps> {
    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;

        return (
            <div className="sitegen-fr-friend-list sitegen-fr-friend-list-no-friends">
                <div className="sitegen-fr-friend-list-no-friends__header">
                    <div className="sitegen-fr-friend-list-no-friends__title">
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.INVITE_FRIENDS)}
                    </div>
                </div>

                <div className="sitegen-fr-friend-list-no-friends__content">
                    <div className="sitegen-fr-friend-list-no-friends__title">
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.NO_FRIENDS_TITLE)}
                    </div>

                    <div className="sitegen-fr-friend-list-no-friends__suggestion">
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.NO_FRIENDS_SUGGESTION)}
                    </div>
                </div>

                <div className="sitegen-fr-friend-list-no-friends__footer">
                    <div className="sitegen-fr-friend-list-no-friends__action-button">
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.INVITE_FRIENDS)}
                    </div>
                </div>
            </div>
        );
    }
}

export const FRFriendListNoFriendsWithTranslations = translate()(FRFriendListNoFriends);
